var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"input-group\">\n<input type=\"text\" class=\"form-control bsszoomfield\" ng-keydown=\"handlekd($event)\" ng-model=\"model[options.key]\">\n<span class=\"input-group-btn\" tabindex=\"-1\">\n<button class=\"btn btn-default\" ng-class=\"{'btn-danger': total===0, 'btn-success': total===1, 'btn-warning': total>=2}\" type=\"button\" ng-click=\"aprigriglia()\">\n>\n</button>\n</span>\n</div> ";
var id1="bsszoom.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;